document.addEventListener('DOMContentLoaded', function () {
  var drawers = {
    cart: document.getElementById('at-cart-drawer'),
    search: document.getElementById('at-search-drawer'),
  };

  function closeAll() {
    Object.keys(drawers).forEach(function (key) {
      var drawer = drawers[key];
      if (drawer) {
        drawer.classList.remove('is-expanded');
      }
    });
    document.removeEventListener('keydown', onEscape);
  }

  function onEscape(event) {
    if (event.key === 'Escape') {
      closeAll();
    }
  }

  function openDrawer(name) {
    closeAll();
    var drawer = drawers[name];
    if (!drawer) return;
    drawer.classList.add('is-expanded');
    document.addEventListener('keydown', onEscape);
    var searchInput = drawer.querySelector('input[type="search"]');
    if (name === 'search' && searchInput) {
      searchInput.focus();
    }
  }

  document.addEventListener('click', function (event) {
    var openTrigger = event.target.closest('[data-drawer-open]');
    if (openTrigger) {
      event.preventDefault();
      openDrawer(openTrigger.getAttribute('data-drawer-open'));
      return;
    }
    var closeTrigger = event.target.closest('[data-drawer-close]');
    if (closeTrigger) {
      event.preventDefault();
      closeAll();
    }
  });

  window.atDrawers = {
    open: openDrawer,
    close: closeAll,
  };

  /* Cart upsell quick add (snippets/cart-upsells). The cart is rendered by
     Liquid, so after an AJAX add the page reloads and the drawer reopens from a
     sessionStorage flag, showing the new line, progress and upsells. A failed
     add falls back to the plain form post (lands on /cart). */
  var REOPEN_KEY = 'at-reopen-cart';

  try {
    if (sessionStorage.getItem(REOPEN_KEY)) {
      sessionStorage.removeItem(REOPEN_KEY);
      openDrawer('cart');
      // The count just went up: pop the header badge (assets/motion.css).
      var badge = document.querySelector('.at-header-cart-count');
      if (badge) badge.classList.add('is-bumped');
    }
  } catch (e) {
    /* storage unavailable: nothing to reopen */
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('[data-cart-quick-add]');
    if (!form || !window.fetch) return;
    event.preventDefault();
    var button = form.querySelector('button[type="submit"]');
    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      /* Swap only the label span: replacing the button's textContent drops the icon and
         changes the button's size. */
      var label = button.querySelector('.at-product-card-quick-add-text');
      if (label && button.dataset.addingLabel) label.textContent = button.dataset.addingLabel;
    }
    fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form),
    })
      .then(function (response) {
        if (!response.ok) throw new Error('add failed');
        try {
          sessionStorage.setItem(REOPEN_KEY, '1');
        } catch (e) {
          /* reload still shows the updated cart count */
        }
        window.location.reload();
      })
      .catch(function () {
        form.submit();
      });
  });
});

/* Accordion open/close animation for every theme <details> accordion (product
   FAQ, homepage offer FAQ, PDP buy-card rows). Native <details> snaps open, so
   the summary click is intercepted and the height is animated with the Web
   Animations API; the `open` attribute still drives semantics and styling.
   Skipped when the visitor prefers reduced motion. */
(function () {
  var SELECTOR = 'details.at-product-faq-item, details.at-faq-item, details.at-product-accordion-item';
  var DURATION = 320;
  var EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.addEventListener('click', function (event) {
    var summary = event.target.closest('summary');
    if (!summary) return;
    var details = summary.parentElement;
    if (!details || !details.matches(SELECTOR) || reduced.matches) return;
    event.preventDefault();

    if (details._atAnimation) details._atAnimation.cancel();
    var startHeight = details.offsetHeight;
    var opening = !details.open;

    if (opening) details.open = true;
    var closedHeight = summary.offsetHeight +
      parseFloat(getComputedStyle(details).paddingTop) +
      parseFloat(getComputedStyle(details).paddingBottom) +
      parseFloat(getComputedStyle(details).borderTopWidth) +
      parseFloat(getComputedStyle(details).borderBottomWidth);
    // Measured after `open` is set and before any inline height is applied, so
    // this is the row's real laid-out height including padding and borders.
    var endHeight = opening ? details.offsetHeight : closedHeight;

    details.style.overflow = 'hidden';
    var animation = details.animate(
      [{ height: startHeight + 'px' }, { height: endHeight + 'px' }],
      { duration: DURATION, easing: EASING }
    );
    details._atAnimation = animation;
    animation.onfinish = function () {
      if (!opening) details.open = false;
      details.style.overflow = '';
      details._atAnimation = null;
    };
    animation.oncancel = function () {
      details.style.overflow = '';
    };
  });
})();

/* Header menus — Hydrogen's MobileMenu and NavShopDropdown. Both fade in with an
   8px drop (Hydrogen's spring: opacity 0→1, translateY(-8px)→0) using the Web
   Animations API; the `hidden` attribute is the closed state, so closed panels
   are out of the tab order. Reduced motion skips the animation. */
(function () {
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  var FRAMES_IN = [
    { opacity: 0, transform: 'translateY(-8px)' },
    { opacity: 1, transform: 'translateY(0)' },
  ];
  // Hydrogen's menu spring (tension 300 / friction 28) as a sampled linear()
  // easing from assets/motion.css; the cubic-bezier is the fallback.
  var springEasing = getComputedStyle(document.documentElement).getPropertyValue('--ease-spring-soft').trim();
  var TIMING = {
    duration: 540,
    easing: springEasing && CSS.supports('transition-timing-function', springEasing)
      ? springEasing
      : 'cubic-bezier(0.22, 1, 0.36, 1)',
  };

  function show(panel) {
    if (panel._atAnim) panel._atAnim.cancel();
    panel.hidden = false;
    if (!reduced.matches) panel._atAnim = panel.animate(FRAMES_IN, TIMING);
  }

  function hide(panel) {
    if (panel.hidden) return;
    if (panel._atAnim) panel._atAnim.cancel();
    if (reduced.matches) {
      panel.hidden = true;
      return;
    }
    var anim = panel.animate(FRAMES_IN.slice().reverse(), TIMING);
    panel._atAnim = anim;
    anim.onfinish = function () {
      panel.hidden = true;
      panel._atAnim = null;
    };
  }

  /* ---- Mobile menu ---- */
  function mobilePanel() {
    return document.querySelector('[data-mobile-menu]');
  }

  function setToggles(expanded) {
    document.querySelectorAll('[data-mobile-menu-open]').forEach(function (btn) {
      btn.setAttribute('aria-expanded', String(expanded));
    });
  }

  function openMobile() {
    var panel = mobilePanel();
    if (!panel) return;
    show(panel);
    document.documentElement.classList.add('at-mobile-menu-open');
    setToggles(true);
    var close = panel.querySelector('[data-mobile-menu-close]');
    if (close) close.focus();
  }

  function closeMobile() {
    var panel = mobilePanel();
    if (!panel || panel.hidden) return;
    hide(panel);
    document.documentElement.classList.remove('at-mobile-menu-open');
    setToggles(false);
    var toggle = document.querySelector('[data-mobile-menu-open]');
    if (toggle) toggle.focus();
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('[data-mobile-menu-open]')) {
      event.preventDefault();
      openMobile();
      return;
    }
    if (event.target.closest('[data-mobile-menu-close]')) {
      event.preventDefault();
      closeMobile();
      return;
    }
    // A link inside the menu navigates away — close so a bfcache restore
    // doesn't come back with the menu still covering the page.
    if (event.target.closest('[data-mobile-menu] a')) closeMobile();
  });

  window.addEventListener('pageshow', function () {
    var panel = mobilePanel();
    if (panel && !panel.hidden) {
      panel.hidden = true;
      document.documentElement.classList.remove('at-mobile-menu-open');
      setToggles(false);
    }
  });

  /* ---- Desktop shop dropdown ---- */
  var CLOSE_DELAY = 120;

  function bindDropdown(item) {
    if (item._atBound) return;
    item._atBound = true;
    var panel = item.querySelector('[data-nav-dropdown-panel]');
    var trigger = item.querySelector('a[aria-controls]');
    if (!panel) return;
    var timer;

    function open() {
      clearTimeout(timer);
      if (panel.hidden) show(panel);
      if (trigger) trigger.setAttribute('aria-expanded', 'true');
    }
    function close() {
      timer = setTimeout(function () {
        hide(panel);
        if (trigger) trigger.setAttribute('aria-expanded', 'false');
      }, CLOSE_DELAY);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget)) close();
    });
  }

  function bindAll() {
    document.querySelectorAll('[data-nav-dropdown]').forEach(bindDropdown);
  }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    closeMobile();
    document.querySelectorAll('[data-nav-dropdown-panel]').forEach(function (panel) {
      hide(panel);
    });
    document.querySelectorAll('[data-nav-dropdown] a[aria-controls]').forEach(function (a) {
      a.setAttribute('aria-expanded', 'false');
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll);
  } else {
    bindAll();
  }
  document.addEventListener('shopify:section:load', bindAll);
})();
